import React from "react";
import "./index.css";

const CustomErrorBoundary = ({ error }) => {
  return (
    <header>
      <div className="error_container">
        <div className="error_icon-container">
          <i className="far fa-frown-open" />
        </div>
        <div className="error_text-container">
          <h2>
            Random Error <span>{error}</span>!
          </h2>
          <p>
            The page you are trying to access occurred some <span>errors</span>
          </p>
          <div className="error_btn-container">
            <button className="error_btn" onclick={window.location.reload()}>
              Reload Page
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CustomErrorBoundary;
